export const postersQueryKeys = {
  all: ["posters"] as const,
  list: () => [...postersQueryKeys.all, "list"] as const,
};
